<div class="gwc-layout">
	<!-- Mobile Menu - There is no desktop header-->
	<header class="gwc-header">
		<section class="gwc-header__section">
			<mat-toolbar class="gwc-header-toolbar">
				<div>
					<gwc-mobile-menu />
				</div>
				<div class="gwc-header-toolbar__panel">
					<mat-menu #mobileProfileMenu="matMenu"
						class="gwc-layout__dropmenu">
						<button mat-menu-item
							(click)="logout()">
							Logout
						</button>
					</mat-menu>
					<button mat-icon-button 
						[matMenuTriggerFor]="mobileProfileMenu"
						class="gwc-header__avatar">
						@if (user()?.avatar) {
							<img [src]="user()!.avatar" />
						}
					</button>
				</div>
			</mat-toolbar>
		</section>
	</header>
	<main class="gwc-layout-content"
		[class.gwc-layout-content--esign]="router.url.includes('/esign')">
		@if (user()) {
			<!-- Desktop Sidebar Menu -->
			<section class="gwc-layout-content__section">
				<!-- Sidebar menu is hidden on mobile -->
				<aside class="gwc-layout-content__menu">
					<div class="gwc-layout-content__user">
						<img [src]="user()!.avatar" />
						<h2>{{ user()!.first_name }} {{ user()!.last_name }}</h2>
						<button mat-button
							color="primary"
							class="gwc-layout-content__user-logout"
							(click)="logout()"
							type="button">
							Log Out
						</button>
					</div>
					<div class="gwc-layout-content__menu-links">
						<a class="gwc-layout-content__link"
							[routerLink]="['/orders']"
							[class.gwc-layout-content__link--active]="router.url.startsWith('/orders') || router.url.startsWith('/order')">
							<p>
								<span class="gwc-layout-content__link-icon">
									<svg><use href="assets/svg/sidebar-icons.svg#icon-passport"></use></svg>
								</span>
								<span class="gwc-layout-content__link-text">My Orders</span>
							</p>
						</a>
						<!-- TODO: To be uncommented -->
						<!-- <a class="gwc-layout-content__link"
							[routerLink]="['/profiles']"
							routerLinkActive="gwc-layout-content__link--active">
							<p>
								<span class="gwc-layout-content__link-icon">
									<svg><use href="assets/svg/sidebar-icons.svg#icon-user"></use></svg>
								</span>
								<span class="gwc-layout-content__link-text">My Profiles</span>
							</p>
						</a> -->
						<!-- TODO: To be uncommented -->
						<!-- <a class="gwc-layout-content__link"
							[routerLink]="['/account']"
							routerLinkActive="gwc-layout-content__link--active">
							<p>
								<span class="gwc-layout-content__link-icon">
									<svg><use href="assets/svg/sidebar-icons.svg#icon-profile"></use></svg>
								</span>
								<span class="gwc-layout-content__link-text">My Account</span>
							</p>
						</a> -->
						<a class="gwc-layout-content__link"
							[routerLink]="['/inbox']"
							routerLinkActive="gwc-layout-content__link--active">
							<p>
								<span class="gwc-layout-content__link-icon">
									<svg width="36"
										height="36">
										<use href="assets/svg/sidebar-icons.svg#icon-message"></use>
									</svg>
								</span>
								<span class="gwc-layout-content__link-text">Message Center</span>
							</p>
						</a>
					</div>
				</aside>
				<router-outlet></router-outlet>
			</section>
		}
	</main>
</div>
